<template>
	<div id="loading" v-show="loadingShow">
		<div class="loadingIcon"></div>
	</div>
</template>
<script type="text/javascript">
	export default{
		props:{
			loadingShow:{
				type:Boolean,
				default:false
			}
		},
		data () {
			return{
				
			}
		}
	}
</script>
<style type="text/css" scoped>
	#loading{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.3);
		z-index: 1000;
		position: fixed;
		top:0;
		left: 0;
	}
	.loadingIcon{
		width: 5vw;
		height: 5vw;
		max-width: 30px;
		max-height: 30px;
		position: absolute;
		top:50%;
		left: 50%;
		transform: translate(-50%,-50%);
		-webkit-transform: translate(-50%,-50%);
		background-image: url("./img/loading.gif");
		background-size: 100% 100%;
	}
</style>